import styled from 'styled-components';

export const AccountProductsWrapper = styled.div`
  /* background-color: #e5e5e5; */
`;
